import Dropzone from "react-dropzone";
import {
  showToastError,
  showToastSuccess,
} from "../../../../services/Toasts/toasts";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { usePartnerWorkingFolderStore } from "../../../../stores/Cac/Partner/partnerWorkingFolder";
import {
  deleteFileWorkingFolder,
  postAccessWorkingFolder,
  postWorkingFolderFile,
} from "../../../../services/Api/customerService";
import upload from "../../../../assets/icons/upload-cloud.svg";
import x from "../../../../assets/icons/x.svg";
import verify from "../../../../assets/icons/verifie.png";
import { useLoaderFile } from "../../../../stores/Utils/loaderFile";
import LoadingUploadFile from "../Utils/LoadingUploadFile";
import { useEffect, useState } from "react";

const TableAndUploadFile = () => {
  const { t } = useTranslation();
  const { idCustomer, idWorkingFolder } = useParams();
  const { updateWorkingFolder, setUpdateWorkingFolder, workingFolderDetails } =
    usePartnerWorkingFolderStore();
  const { setPercent, isLoading, setIsLoading } = useLoaderFile();

  const handleUploadClick = async (files: File[]) => {
    setIsLoading(true);
    try {
      postWorkingFolderFile(
        Number(idCustomer),
        Number(idWorkingFolder),
        files,
        (progressEvent) => {
          console.log(progressEvent);
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );

          setPercent(percentCompleted);
        }
      )
      .then(() => {
        setIsLoading(false);
        showToastSuccess("Fichier téléchargé avec succès");
        setUpdateWorkingFolder(!updateWorkingFolder);
        setPercent(0);
      })
      .catch(() => {
        setIsLoading(false);
      });
    } catch (error) {
      showToastError("Format accepté : zip");
      setIsLoading(false);
      setPercent(0);
    }
  };

  console.log(isLoading);

  const handleDrop = (acceptedFiles: File[]) => {
    handleUploadClick(acceptedFiles);
  };

  const handleDeleteFile = () => {
    deleteFileWorkingFolder(Number(idCustomer), Number(idWorkingFolder))
      .then(() => {
        setUpdateWorkingFolder(!updateWorkingFolder);
        showToastSuccess("Fichier supprimé avec succès");
      })
      .catch(() => showToastError("Erreur lors de la suppression du fichier"));
  };

  const handleSendAccess = () => {
    postAccessWorkingFolder(Number(idCustomer), Number(idWorkingFolder))
      .then(() => {
        setUpdateWorkingFolder(!updateWorkingFolder);
        showToastSuccess("Accès envoyé avec succès");
      })
      .catch(() => showToastError("Erreur lors de l'envoi de l'accès"));
  };
  const [block, setBlock] = useState<boolean>(false);

  useEffect(() => {
    if (workingFolderDetails?.workingFolder?.accessUsers.length > 0) {
      // Vérifier si TOUS les utilisateurs ont sendDate === null
      const allUsersHaveNullSendDate = workingFolderDetails.workingFolder.accessUsers.every(
        (user: any) => user.sendDate === null
      );
      if (!allUsersHaveNullSendDate) {
        setBlock(true);
      } else {
        setBlock(false);
      }
    } else {
      setBlock(false);
    }
  }, [workingFolderDetails]);

  return (
    <div className="w-full h-full flex flex-col justify-start items-center">
      {workingFolderDetails?.workingFolder?.hasFile && !isLoading ? (
        <div className="flex justify-center items-center p-8">
          <div className="text-center">
            <img src={verify} alt="verify" className="w-24 h-32 mx-auto mb-4" />
            <p className="text-green-600 font-medium">{t("workingFolder.downloadSuccess")}</p>
          </div>
        </div>
      ) : !workingFolderDetails?.workingFolder?.hasFile && !isLoading ? (
        <Dropzone onDrop={handleDrop} multiple={false}>
          {({ getRootProps, getInputProps }) => (
            <div
              {...getRootProps()}
              className="w-full m-auto bg-gray-50 border-2 border-dashed border-gray-300 hover:border-blue-400 hover:bg-blue-50 rounded-xl p-8 cursor-pointer flex flex-col items-center justify-center transition-all duration-200"
            >
              <input {...getInputProps()} />
              <img
                src={upload}
                alt="upload"
                className="2xl:w-20 2xl:h-20 w-16 h-16 text-gray-400 mb-4"
              />
              <p className="text-center text-gray-600 hover:text-gray-800 font-medium mb-2">
                {t("partner.dropFile")}
              </p>
              <p className="text-center text-sm text-gray-500">
                {t("partner.orClick")}
              </p>
            </div>
          )}
        </Dropzone>
      ) : isLoading ? (
        <div className="flex justify-center items-center w-full m-auto p-8">
          <LoadingUploadFile />
        </div>
      ) : null}

      {/* Section informations du fichier */}
      <div className="w-full p-4 bg-gray-50 rounded-lg">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <span className="font-semibold text-gray-700">{t("partner.file")} :</span>
            <span className="text-gray-600">
                {workingFolderDetails?.workingFolder?.hasFile
                  ? workingFolderDetails?.workingFolder?.fileName
                : t("partner.noFileUploaded")}
            </span>
          </div>
          {workingFolderDetails?.workingFolder?.hasFile && (
            <button
              onClick={handleDeleteFile}
              className="p-2 text-red-500 hover:text-red-700 hover:bg-red-50 rounded-lg transition-colors duration-200 cursor-pointer"
              title={t("partner.deleteFile")}
            >
              <img src={x} alt="supprimer" className="w-4 h-4" />
            </button>
          )}
        </div>
      </div>

      {/* Section envoi d'accès */}
      {!block && workingFolderDetails?.workingFolder?.hasFile && (
        <div className="w-full mt-2 p-2 bg-blue-50 rounded-lg border border-blue-200 ">
          <p className="text-blue-800 text-sm text-center pb-2">
            {t("partner.sendAccessHint")}
          </p>
          <div className="flex justify-center">
            <button
              onClick={handleSendAccess}
              className="px-6 py-2 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transform hover:scale-105 transition-all duration-200 shadow-md hover:shadow-lg cursor-pointer"
            >
              {t("partner.sendAccess")}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default TableAndUploadFile;
